/**
 * Created by stonewang on 2017/9/11.
 */
import {config, request} from 'Utils';

//PC查询新闻的评论列表
export function commentListByPC(param) {
  /*
   {
   "content": "string",
   "newsId": 0,
   "p": 0,
   "s": 0,
   }
  * */
  return request(`${config.server}/api/v1/dms/news/commentListByPC`, {
    method: 'post',
    body: param,
  });
}
//新增新闻评论(含转发)
export function insertNewsComment(param) {
  /*
   {
   content (string, optional),
   newsId (integer, optional),
   p (integer, optional): 页码 ,
   s (integer, optional): 每页条数 ,
   }
  * */
  return request(`${config.server}/api/v1/dms/news/insertNewsComment`, {
    method: 'post',
    body: param,
  });
}
//删除评论
export function deleteComment(param) {
  /*
   {
   "ids": [
   0
   ],
   "status": 0,
   "type": 0
   }
   * */
  return request(`${config.server}/api/v1/dms/news/deleteComment`, {
    method: 'post',
    body: param,
  });
}
//评论置顶
export function commentTop(param) {
  /*
   {
   "ids": [
   0
   ],
   "status": 0,
   "type": 0
   }
  * */
  return request(`${config.server}/api/v1/dms/news/commentTop`, {
    method: 'post',
    body: param,
  });
}


// WEBPACK FOOTER //
// ./src/service/info/comment.js